import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function brochureApi(path: string) {
  return {
    path,
    GET: () => api.get<JsonApiResponseSingle>(path),
  };
}
